export default __webpack_public_path__ + "static/media/mathsFloating.6d7a1e6d.svg";